// Boundary wrapper around `ajax.upsertProgram`. The generated OpenAPI type
// mistypes enum columns as `object` and `duration` as `Array<string>`. The
// single `as unknown as` here reconciles the broken generated type with
// reality - same place `collection.model.ts` resorts to `as any`.
import ajax from '@client/components/ajax';
import { ProgramUpsertRequest } from '../model/programForm.mapper';
import { savedProgramSchema, SavedProgram } from './programForm.response';

type UpsertProgramFn = (payload: ProgramUpsertRequest) => Promise<unknown>;

// Thrown when the upsert HTTP call succeeded but the response did not match
// the expected `{ id }` shape. The save happened; the client just cannot
// continue the post-save flow (refetch + navigate). Caller distinguishes
// this from a true save failure so the user is not told "Failed to save"
// when their record was created.
export class SavedProgramParseError extends Error {
  constructor(public raw: unknown, public cause: unknown) {
    super('Saved program response did not match expected shape');
    this.name = 'SavedProgramParseError';
  }
}

export const upsertProgram = async (
  payload: ProgramUpsertRequest,
): Promise<SavedProgram> => {
  const callUpsert = ajax.upsertProgram as unknown as UpsertProgramFn;
  const raw = await callUpsert(payload);
  try {
    return savedProgramSchema.parse(raw);
  } catch (error) {
    throw new SavedProgramParseError(raw, error);
  }
};
